import React from "react";
import PropTypes from "prop-types";
import Icon from "../icon";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { maskPhoneNumber } from "../../utils/siteUtils";

const VerificationMethod = ({ className, body, phoneArea, phoneNumber, onClick, method }) => {
  let phone = { value: maskPhoneNumber(phoneArea, phoneNumber) };

  return (
    <div className={className} onClick={onClick}>
      <div className="verification-method" data-method={method}>
        <div className="verification-method-icon">
          <Icon name="Phone" />
        </div>
        <div className="verification-method-body">
          <div>
            <RichText field={body} />
            <RichText field={phone} />
          </div>
        </div>
        <div className="verification-method-arrow">
          <Icon className="verification-method-arrow-icon" name="ArrowForward" />
        </div>
      </div>
    </div>
  );
};

VerificationMethod.propTypes = {
  titleType: PropTypes.object,
  titleBody: PropTypes.object
};

export default VerificationMethod;
